import gql from 'graphql-tag';

export default gql`
    query GetBets($input: BetsInput!) {
        bets(input: $input) {
            stake
        }
    }
`;
